export const ToothIcon = ({ fill }: { fill?: string }) => {
  return (
    <svg
      width="11"
      height="14"
      viewBox="0 0 11 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.60938 2.24219L4.58594 2.21875L5.45312 2.89844L6.03906 3.34375C6.20312 3.48438 6.4375 3.4375 6.55469 3.27344C6.69531 3.10938 6.67188 2.875 6.50781 2.75781L6.03906 2.40625L6.10938 2.33594C6.53125 1.96094 7.09375 1.75 7.65625 1.75C8.94531 1.75 9.97656 2.80469 9.97656 4.09375V4.14062C9.97656 4.51562 9.90625 4.86719 9.74219 5.21875L9.17969 6.32031C9.08594 6.53125 9.01562 6.74219 8.96875 6.97656L8.10156 11.8047C8.05469 12.0625 7.84375 12.25 7.5625 12.25C7.30469 12.2734 7.07031 12.0859 7 11.8281L6.32031 8.99219C6.22656 8.59375 5.89844 8.3125 5.5 8.3125C5.10156 8.3125 4.75 8.59375 4.65625 8.99219L3.97656 11.8281C3.90625 12.0859 3.67188 12.2734 3.41406 12.2734C3.13281 12.25 2.92188 12.0625 2.875 11.8047L2.00781 6.97656C1.96094 6.74219 1.89062 6.53125 1.79688 6.32031L1.23438 5.21875C1.07031 4.86719 1 4.51562 1 4.14062V4C1 2.75781 1.98438 1.75 3.22656 1.75C3.71875 1.75 4.21094 1.9375 4.60938 2.24219Z"
        fill={fill || '#3F3F46'}
      />
    </svg>
  );
};
